import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TotalFloorsField from '../totalFloorsField/TotalFloorsField'
import FloorNumberField from '../floorNumberField/FloorNumberField'
import { InputLabel } from '../../../../../../common/display/labelText/LabelText'

type FloorProps = {
  id?: string
  wrapperClassName?: string
  levitatingContentWrapperClassName?: string
}
const FloorAndTotalFloor: React.FC<FieldProps<OtherFacilitiesScreenValidationResult> & FloorProps> = ({
  wrapperClassName,
  levitatingContentWrapperClassName,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <div className={`${wrapperClassName ?? ''}`}>
      <InputLabel id='floor' labelTranslationKey='wizard.screen.otherFacilities.floorNumber' propertyName='floor' />
      <div className={`grid grid-flex gutter-xs grid-justify-space-between ${levitatingContentWrapperClassName ?? ''}`}>
        <div className='grid-item desk-two-fifth lap-two-fifth palm-two-fifth padding-left-xs'>
          <FloorNumberField {...props} />
        </div>
        <div className='grid-item margin-top'>{t('wizard.screen.otherFacilities.from', 'from')}</div>
        <div className='grid-item desk-two-fifth lap-two-fifth palm-two-fifth' data-testid='total-floors-number-field'>
          <TotalFloorsField {...props} inputType='tel' isLabelDisplayed={false} />
        </div>
      </div>
    </div>
  )
}

export default FloorAndTotalFloor
